var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    selector_filters: [],
};
export var filterSlice = createSlice({
    name: "filter",
    initialState: initialState,
    reducers: {
        setFiltersSelected: function (state, data) {
            state.selector_filters = data.payload;
        },
        setTotalCount: function (state, data) {
            state.total_count = data.payload;
        },
        setElementCountPerPage: function (state, data) {
            state.element_per_page = data.payload;
        },
    },
});
export var setFiltersSelected = (_a = filterSlice.actions, _a.setFiltersSelected), setTotalCount = _a.setTotalCount, setElementCountPerPage = _a.setElementCountPerPage;
export default filterSlice.reducer;
